/*
 * Winy Mind Pvt. Ltd.
 * Created by suraj on 20/10/23, 3:51 pm
 * Copyright (c) 2023 . All rights reserved.
 * Last modified 20/10/23, 3:51 pm
 */

package tta.destinigo.talktoastro.feature_chat_consultation_new.data.response.concern_question

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ConcerQuestionsResponse(
    @SerialName("data") val `data`: List<ConcernQuestions>,
    @SerialName("status")
    val status: Boolean?,
    @SerialName("message")
    val message: String?,
    @SerialName("code")
    var code: Int = 0
)